var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgTwoFaKey = function SvgTwoFaKey(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payments, Finance/Bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 9.08775C18.25 13.7881 14.7306 18.1844 10 19.251C5.26941 18.1834 1.75 13.7881 1.75 9.08775V5.39416C1.75 4.55263 2.2571 3.79525 3.0319 3.47791L8.18777 1.35989C9.34946 0.881338 10.6516 0.881338 11.8112 1.35989L16.9671 3.47791C17.7429 3.79728 18.249 4.55263 18.249 5.39416L18.25 9.08775V9.08775Z",
    stroke: "#00BD78",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xF4\x81\x8E\x95",
    d: "M9.90753 5.25098C11.2929 5.25098 12.4119 6.37758 12.4119 7.75538C12.4119 8.79064 11.7877 9.65082 10.6764 10.138L11.5746 11.0515C11.6964 11.1733 11.6964 11.3559 11.5822 11.4625L10.6459 12.3988L11.3082 13.0611C11.4224 13.1829 11.43 13.3579 11.3082 13.4797L10.1131 14.6672C9.99887 14.7814 9.83902 14.7738 9.73245 14.6749L9.07019 14.0354C8.97884 13.9517 8.93317 13.8451 8.92556 13.7233V10.0771C7.99687 9.68888 7.39551 8.79064 7.39551 7.75538C7.39551 6.37758 8.50689 5.25098 9.90753 5.25098ZM9.89991 6.47654C9.48886 6.47654 9.14631 6.81909 9.14631 7.23014C9.14631 7.64881 9.48886 7.99136 9.89991 7.99136C10.311 7.99136 10.6535 7.64881 10.6535 7.23014C10.6535 6.81909 10.311 6.47654 9.89991 6.47654Z",
    fill: "#00BD78"
  }))));
};
export default SvgTwoFaKey;